<template>
  <div style="margin-bottom:300px;">
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->



<div  v-if="editSt && taskExist"  class="text-center"  style="margin-top:30px;margin-bottom:50px;max-width:300px;margin-left:auto;margin-right:auto;">
     <p-button type="default"  block round  @click.prevent="goToTask">View Task & Resolution</p-button> 
</div>


<div v-if="editSt" >
<h4 style="font-weight:bold;">Shareholder Details</h4>

</div>



<card  class="form-horizontal" style="background-color:#ccc">

	
	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Shareholder Name</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{model.first_name}}  {{model.last_name}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{model.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{model.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Email</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{model.email}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label1" >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{model.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
</card>



<card v-if="shareholderCompanyFound" class="form-horizontal" style="background-color:#ccc">
    <h5  slot="header" class="card-title" style="margin-bottom:-20px">
      <span style="font-weight:bold;">Company Name: &nbsp;</span> {{shareholderCompany.company_name}} 
    </h5>

	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Company Registration Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.company_reg_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Company Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.address}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Place Of Incorporation</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.country}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    

    
    
</card>

<card v-if="shareholderCompanyFound" class="form-horizontal" style="background-color:#ccc">
    <h5  slot="header" class="card-title" style="margin-bottom:-20px">
      <span style="font-weight:bold;">Representative Name: &nbsp;</span> {{shareholderCompany.person.first_name}}  {{shareholderCompany.person.last_name}}
    </h5>

	<div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >ID Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.person.gov_id}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Address</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.person.address_1}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Email</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.person.email}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row cs_coy_detail_row" >
      <label class="col-sm-2 col-form-label cs_coy_detail_label" >Contact Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shareholderCompany.person.contact_num}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
</card>






	<div style="margin-top:50px;">
       <h4 v-if="editSt"  slot="header" class="card-title" style="font-weight:bold;">
      Change: Share Certificate Details
    </h4>
    </div>
  
  <card  v-if="createTransactionForm" class="form-horizontal">
   



    <div class="row"  style="margin-bottom:30px;">
      <label class="col-sm-2 col-form-label">Change Type</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        	 <span v-if="shares.type===1">Issue Certificate</span>
           	 <span v-if="shares.type===2">Cancel Certificate</span>
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row"  style="margin-bottom:30px;">
      <label class="col-sm-2 col-form-label">Share Certificate Number</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        	 #{{shares.share_certificate.cert_number}}
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    


    
     <div class="row"  style="margin-bottom:30px;">
      <label class="col-sm-2 col-form-label">Share Type</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">
        				 <span v-if="shares.share_certificate.share_type===1">Ordinary</span>
           				 <span v-if="shares.share_certificate.share_type===2">Preference</span>
        
        </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row" style="margin-bottom:30px;">
      <label class="col-sm-2 col-form-label">Number Of Shares</label>
      <div class="col-sm-7">
        <div  class="cs_coy_detail_">{{shares.share_certificate.num_shares}}</div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="shares.effective_date" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Filing Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="shares.filing_date" type="date" placeholder="Select A Date"
                               >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       	   <textarea 
        		 cols="45" rows="10"
                  name="notes"
                  v-model="shares.notes">
       	 </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
             	<span style="font-size:11px;"><i> * Add your notes, ACRA transaction code, etc.</i></span>

      </div>
    </div>
    
    
    
    
    
    
     <div v-if="personFound && editSt==false" slot="footer" class="text-center">
      <p-button   type="info" @click.prevent="validateShares">Submit New Share Transaction</p-button>
    </div>
    
    
    
    
    
     <div v-if="false">
    <!-- <div v-if="editSt && !taskExist" class="text-center"  style="margin-top:30px;margin-bottom:50px;"> -->
      <p-button   type="default" @click.prevent="goToCreateTaskDetails">Create Resolution & New Task</p-button>
    </div>
    
   
    
</card>

	<div style="margin-top:100px;">
	<h4 class="title">Status</h4>
   </div>
   <card style="margin-bottom:100px;">
   		 <div  v-if="editSt" class="row">
      <label class="col-sm-2 col-form-label">Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="shares.status">
                    <el-option v-for="option in selects.st_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
		  </div>
		  <div class="col-sm-3 label-on-right">
			<code></code>
		  </div>
		</div>
   
   </card>
   
   
	<h4 style="font-weight:bold;">Actions</h4>	  
	<card>
	
		 <div v-if="editSt" >
    	  <p-button   type="info" @click.prevent="validateUpdateShareCert">Update Share Certificate</p-button>
    	</div>
    
	 
	</card>
	
          
 <div v-if="0" slot="footer" class="text-center">
      <p-button v-if="createForm"  type="info" @click.prevent="validate">Submit New Shareholder</p-button>
   <p-button v-if="editSt" type="danger"  @click="deleteSt()" >
                <i slot="label" class="nc-icon nc-simple-remove"></i>
                <span style=""> Delete This Change: Shares </span>
     </p-button>
    </div>



  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	if(this.$route.params.sccid){
     		     		
     		let uri = this.$base_url+'/api/v1/shareholders/share_cert_change/'+ this.$route.params.sccid;
			 ApiService.get(uri).then(response => {
		
				this.shares = response.data.scc;
				let p = response.data.scc;
				
				if(p.shareholder.person){
					this.model = p.shareholder.person;
					this.personFound = true;
				}
				
				if(p.shareholder.shareholder_company){
					this.shareholderCompany = p.shareholder.shareholder_company;
					this.shareholderCompanyFound = true;
				}
				
				
				
				
				this.editSt = true;
				this.createTransactionForm = true;
				
				if(this.shares.task_id){
					this.taskExist = true;
				}
				else{
					this.shares.task_id = 0;
				}
			
			})
     		
     	}
    	
     	if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				//this.createForm = false
				//this.model = response.data.entity;
				this.coy = response.data.entity;
				
			
			})
      	}//get connected entity info
      	
      	
      
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	stid: this.$route.params.stid,
    	pid: 0,
    	createForm: false,
    	editSt: false,
    	taskExist: false,
    	showSearchBar: true,
    	createTransactionForm: false,
    	search_id_num: '',
    	personFound: false,
    	shareholderCompanyFound: false,
    	shareholderCompany: '',
    	showTransferFrom: false,
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          effective_date: '',
          position:'',
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        shares :{
        	share_type: 1,
        	num_shares: '',
        	transaction_type:1,
        	paid_up_capital: '',
        	currency:'SGD',
        	effective_date:'',
        	filing_date:'',
        	transfer_tofrom_id:'',
        	status: 1,
        	notes:'',
        	task_id: 0,
        },
        sharesValidations:{
          share_type: {
            required: true
          },
          num_shares: {
            required: true,
          },
         
        },
        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
          status: {
          	required: true,
          },
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
           position: {
            required: true,
          },
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
          
          
        },
        
        selects: {
          share_type: [
            {value: 1, label: 'Ordinary'},
            {value: 2, label: 'Preference'},
		   ],
		  transaction_type:[
            {value: 1, label: 'Increase'},
            {value: 2, label: 'Decrease'},
            {value: 3, label: 'Transfer From Another Shareholder To This Shareholder'},
		   ] ,
		   shareholders_list: [],
		   st_status: [
            {value: 1, label: 'Pending'},
            {value: 4, label: 'Completed'},
		   ],
        },
      }
    },
    methods:{
       deleteSt(){
       		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'Any resolution or task connected to this change will also be deleted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/shareholders/delete_st/'+ vm.$route.params.stid;
          	 
     	  	 ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'This Change: Shares has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					 vm.$router.push( '/view-entity/'+vm.$route.params.eid);
				
				})
				//end swal
            })
         
            
          })
       }, //end delete st
       goToTask(){
       		this.$router.push( '/edit-task/'+ this.shares.task_id + '/entity/'+ this.$route.params.eid)
       },
       goToCreateTaskDetails(){
       		
       		let task_name_sys = "st";
       		
       		if(this.shares.transaction_type == 3 || this.shares.transaction_type == 4){
       			task_name_sys = "stt";
       		}
       		
       
       		this.$router.push( '/create-task-details/'+ this.$route.params.eid+"/"+task_name_sys+"/"+this.$route.params.stid +"/"+this.shares.task_id+"/0")
       },
       onTransactionTypeChange(event){
       		if(this.shares.transaction_type == 3){
       			let uri = this.$base_url+'/api/v1/shareholders/entity/'+this.$route.params.eid;
       		
      			ApiService.get(uri).then(response => {
      				
      				this.selects.shareholders_list = response.data.shareholders;
      				this.showTransferFrom = true;
   
      				
      			});
       		
       		}else{
       			this.showTransferFrom = false;
       		}
       
       },
       searchPerson(){
       		let search_term = "NONE";
       		if(this.search_id_num){
       			search_term = this.search_id_num
       		}
       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;
       		
       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){
      				
      					this.model = response.data.person;
      					this.pid = response.data.person.id;
      					this.personFound = true;
      					this.createForm = false;
      					this.createTransactionForm = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'This person has not been added yet.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.createForm = true;
							vm.personFound = false;
							vm.createTransactionForm = true;
				
						})
      				
      					
      				}
         		
     		 })
    	
    	},

       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	    },
	    
	  validateUpdateShareCert(){
	  	 this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/shareholders/update_scc';

       		const vm = this;
      		ApiService.post(uri, {
      			'eid': this.eid,
      			'sccid': this.$route.params.sccid,
      			'shares': this.shares
      		
      		}).then(response => {
      			vm.$router.push( '/edit-task/'+ response.data.scc.task_id + "/entity/" + response.data.scc.entity_id);
      		
      		})
	  	 
	  	 
	  	 });
	  },  
	    
	  validateShares(){
	  	 this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/shareholders/create';
       	      //alert("debug:"+this.shares.transfer_tofrom_id);
       	        		
       		const vm = this;
      		ApiService.post(uri, {
      			'pid': this.pid,
      			'eid': this.eid,
      			'shares': this.shares
      		
      		}).then(response => {
      		
      			vm.$router.push( '/view-entity/'+ vm.eid)
      		})
	  	 	
	  	 
	  	 });
	  },  
      validate() {
        this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/shareholders/create';
       	      		
       		
       		const vm = this;
      		ApiService.post(uri, {
      			'pid': this.pid,
      			'eid': this.eid,
      			'shares': this.shares,
      			'person': this.model
      		
      		}).then(response => {
      			vm.$router.push( '/view-entity/'+ vm.eid)
      		
      		})
	  	 
	  	 
	  	 });
      },///end validate+create
      
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


